
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("8f2ji", function(module, exports) {
/* ViewXlsMacroRenderer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $glkQ6 = parcelRequire("glkQ6");


var $a86m3 = parcelRequire("a86m3");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $eCryJ = parcelRequire("eCryJ");


var $5kjCz = parcelRequire("5kjCz");


var $bX5uj = parcelRequire("bX5uj");


var $JbVPK = parcelRequire("JbVPK");


var $kCqKs = parcelRequire("kCqKs");

/* HtmlSheetViewer.tsx generated by @compiled/babel-plugin v3.0.2 */ 









var $hBYtq = parcelRequire("hBYtq");




const $289a2ded4c961958$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    errorAttachmentNotFound: {
        id: "viewxls-macro.error.attachment-not-found",
        defaultMessage: "Attachment not found"
    },
    errorNoFilename: {
        id: "viewxls-macro.error.no-filename",
        defaultMessage: "Attachment filename not found"
    },
    errorPageNotFound: {
        id: "viewxls-macro.error.page-not-found",
        defaultMessage: "The viewfile macro is unable to locate the page."
    },
    errorStillProcessing: {
        id: "viewxls-macro.error.still-processing",
        defaultMessage: "The attachment with name {filename} is still being processed, please refresh the page in a moment."
    },
    errorFailedToRetrieve: {
        id: "viewxls-macro.error.failed-to-retrieve",
        defaultMessage: "Failed to retrieve attachment with name {filename}"
    },
    errorGeneric: {
        id: "viewxls-macro.error.generic",
        defaultMessage: "Something went wrong displaying this file."
    },
    thumbnailAlt: {
        id: "viewxls-macro.thumbnail.alt",
        defaultMessage: "Thumbnail preview for {filename}"
    },
    spreadsheetIframeTitle: {
        id: "viewxls-macro.spreadsheet.iframe-title",
        defaultMessage: "Excel spreadsheet: {filename}"
    },
    noticeBannerHeadline: {
        id: "viewxls-macro.notice.headline",
        defaultMessage: "Excel: spreadsheet preview is finally here!"
    },
    noticeBannerBody: {
        id: "viewxls-macro.notice.body",
        defaultMessage: "You can now display this file as a spreadsheet, instead of a PDF. Re-upload {filename} to display the new preview. You can access the file {link}."
    },
    noticeBannerLinkLabel: {
        id: "viewxls-macro.notice.link-label",
        defaultMessage: "here"
    }
});


const $a5b513a4466152da$var$DEFAULT_SHEET_NAME = 'Sheet1'; /**
                                      * Parses the sheet HTML content for a given sheet name from the full HTML artifact.
                                      * Matches elements with data-sheet-name attribute.
                                      */ 
const $a5b513a4466152da$var$getSheetHtml = (htmlContent, sheetName)=>{
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlContent, 'text/html');
    const sheetEl = Array.from(doc.querySelectorAll('[data-sheet-name]')).find((el)=>el.getAttribute('data-sheet-name') === sheetName);
    if (sheetEl) return `<!doctype html><html><head>${doc.head.innerHTML}</head><body>${sheetEl.outerHTML}</body></html>`;
    if (sheetName === $a5b513a4466152da$var$DEFAULT_SHEET_NAME) return htmlContent;
    return '';
};
const $a5b513a4466152da$export$5d1211828338680f = (htmlContent)=>{
    if (!htmlContent.trim()) return [];
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlContent, 'text/html');
    const elements = doc.querySelectorAll('[data-sheet-name]');
    const names = [];
    elements.forEach((el)=>{
        const name = el.getAttribute('data-sheet-name');
        if (name) names.push(name);
    });
    return names.length > 0 ? names : [
        $a5b513a4466152da$var$DEFAULT_SHEET_NAME
    ];
};
const $a5b513a4466152da$var$styles = {
    viewer: "_3iDTPbQ4SZ _0aFT5vbt8w",
    iframeContainer: "_4bt5LAnQyn _2WAcuGnQyn _1mT5xdRAKS",
    tabBar: "_3iDTPbQ4SZ _39xV02W9qI _4ouGXIN91d _3TGfC9LRg7",
    tabButton: "_2sNsIgmnOE _4bt5LAnQyn _2WAcuGnQyn _23rrnHo10F _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _4c065UgVvo _2Y7lL48HPE _24h04i2Njc _0KLXruDMqu _1UtDYzZpcK _0wOv4Q7zJH _39HuIbz8Lp _1ANEUSLRg7 _0jFU0VUofl _4ouGXImpvA _1eOmH6qWX3 _0clgaMGL5O",
    activeTabButton: "_4bt5LAnQyn _2WAcuGnQyn _2sNsIgd8bj _23rrnHo10F _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _4c065UgVvo _2Y7lL48HPE _2R4pr3V9Mu _24h04i2Njc _0KLXru7Cj1 _1UtDYzGL5O _0wOv4Q7zJH _39HuIbz8Lp _1ANEUSLRg7 _0jFU0VUofl _4ouGXImpvA _1eOmH6qWX3 _0clgaMGL5O",
    scroller: "_39xV02N91d _4bt5LAIZbP _2WAcuGnQyn",
    iframe: "_30huDKYbGa _0jFU0VN91d _39xV02N91d _3iDTPbvLZJ _0KLXrulfZc"
}; /**
    * Renders an Excel sheet as an HTML iframe with a tab bar for sheet navigation.
    * Matches the legacy html_viewer.vm template behaviour.
    */ 
const $a5b513a4466152da$export$e8078034ef788eda = ({ htmlContent: htmlContent, sheetNames: sheetNames, width: width, height: height, attachmentName: attachmentName })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [activeSheet, setActiveSheet] = (0, $cozmU.useState)(sheetNames[0] ?? '');
    const viewerId = (0, $cozmU.useId)();
    const iframeRef = (0, $cozmU.useRef)(null);
    const tabPanelId = `${viewerId}-sheet-panel`;
    const getTabId = (0, $cozmU.useCallback)((index)=>`${viewerId}-sheet-tab-${index}`, [
        viewerId
    ]);
    const updateIframe = (0, $cozmU.useCallback)((sheetName)=>{
        const iframe = iframeRef.current;
        if (!iframe) return;
        const sheetHtml = $a5b513a4466152da$var$getSheetHtml(htmlContent, sheetName);
        iframe.srcdoc = sheetHtml;
    }, [
        htmlContent
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (sheetNames.length > 0) {
            const firstSheetName = sheetNames[0];
            setActiveSheet(firstSheetName);
            updateIframe(firstSheetName);
        }
    }, [
        sheetNames,
        updateIframe
    ]);
    const handleTabClick = (0, $cozmU.useCallback)((sheetName)=>{
        setActiveSheet(sheetName);
        updateIframe(sheetName);
    }, [
        updateIframe
    ]);
    const onTabClick = (0, $cozmU.useCallback)((event)=>{
        const sheetName = event.currentTarget.getAttribute('data-sheet-name');
        if (!sheetName) return;
        handleTabClick(sheetName);
    }, [
        handleTabClick
    ]);
    const activeSheetIndex = sheetNames.indexOf(activeSheet);
    const activeTabId = activeSheetIndex >= 0 ? getTabId(activeSheetIndex) : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "viewxls-html-viewer",
        className: (0, $hekY6.default)([
            $a5b513a4466152da$var$styles.viewer
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Dynamic values from macro params cannot be expressed as static CSS
    , {
        style: {
            height: height,
            width: width
        },
        "data-attachment-name": attachmentName,
        className: (0, $hekY6.default)([
            $a5b513a4466152da$var$styles.iframeContainer
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("iframe", {
        ref: iframeRef,
        "data-testid": "viewxls-html-viewer-iframe",
        "data-attachment-name": attachmentName,
        id: tabPanelId,
        role: "tabpanel",
        "aria-labelledby": activeTabId,
        tabIndex: 0,
        sandbox: "allow-same-origin",
        scrolling: "auto",
        title: formatMessage((0, $289a2ded4c961958$export$a7357cdd1f0b0168).spreadsheetIframeTitle, {
            filename: attachmentName
        }),
        className: (0, $hekY6.default)([
            $a5b513a4466152da$var$styles.iframe
        ])
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "viewxls-html-viewer-scroller",
        className: (0, $hekY6.default)([
            $a5b513a4466152da$var$styles.scroller
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "viewxls-html-viewer-tab-bar",
        role: "tablist",
        className: (0, $hekY6.default)([
            $a5b513a4466152da$var$styles.tabBar
        ])
    }, sheetNames.map((sheetName, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            key: sheetName,
            role: "tab",
            id: getTabId(index),
            xcss: sheetName === activeSheet ? $a5b513a4466152da$var$styles.activeTabButton : $a5b513a4466152da$var$styles.tabButton,
            testId: `viewxls-tab-${sheetName}`,
            "data-sheet-name": sheetName,
            "aria-controls": tabPanelId,
            "aria-selected": sheetName === activeSheet,
            onClick: onTabClick,
            type: "button"
        }, sheetName)))));
};


/* NoticeBanner.tsx generated by @compiled/babel-plugin v3.0.2 */ 









var $7vK9E = parcelRequire("7vK9E");


var $4aRua = parcelRequire("4aRua");



var $1HZKG = parcelRequire("1HZKG");

const $dac3ea759b53d371$var$styles = {
    card: "_1mT5xdRAKS _1DCdHi2ADO",
    iconContainer: "_1mT5xdWVPG _0jFU0VN91d _39xV02ljYU",
    iconContent: "_2XghbEPgdg _1mT5xdWVPG _2IhTon715P _3OE6xY715P _1VJPcaiDnZ _0jFU0VjWgP _39xV02jWgP",
    headlineContainer: "_0GTcwRyFLW",
    subtitleContainer: "_0GTcwRyFLW"
};
const $dac3ea759b53d371$export$81dbdf80cb4cbfe = ({ fileName: fileName, attachmentPageUrl: attachmentPageUrl, iconUrl: iconUrl })=>{
    const truncated = (0, $1HZKG.truncateFileName)(fileName);
    const isTruncated = truncated !== fileName;
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": "viewxls-notice-banner",
        className: (0, $hekY6.default)([
            $dac3ea759b53d371$var$styles.card
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $dac3ea759b53d371$var$styles.iconContainer
        ])
    }, /*#__PURE__*/ $cozmU.createElement("img", {
        src: iconUrl,
        alt: "",
        className: (0, $hekY6.default)([
            $dac3ea759b53d371$var$styles.iconContent
        ])
    })), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $dac3ea759b53d371$var$styles.headlineContainer
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        as: "p",
        weight: "bold"
    }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $289a2ded4c961958$export$a7357cdd1f0b0168).noticeBannerHeadline))), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $dac3ea759b53d371$var$styles.subtitleContainer
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        as: "p"
    }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $289a2ded4c961958$export$a7357cdd1f0b0168).noticeBannerBody,
        values: {
            filename: isTruncated ? /*#__PURE__*/ $cozmU.createElement("span", {
                title: fileName
            }, truncated) : /*#__PURE__*/ $cozmU.createElement("span", null, fileName),
            link: /*#__PURE__*/ $cozmU.createElement((0, $7vK9E.Anchor), {
                href: attachmentPageUrl
            }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $289a2ded4c961958$export$a7357cdd1f0b0168).noticeBannerLinkLabel))
        }
    }))));
};







var $brX63 = parcelRequire("brX63");


var $jMyy4 = parcelRequire("jMyy4");


var $2zpUM = parcelRequire("2zpUM");

const $84092145cc3f41e1$export$d6d02870d99f0782 = ({ contentId: contentId, attachmentName: attachmentName, pageName: pageName, spaceKey: spaceKey, date: date })=>{
    const normalizedPageName = pageName?.trim() || null;
    const isCrossPage = Boolean(normalizedPageName);
    const skip = !contentId || !attachmentName;
    const variables = (0, $2zpUM.buildOfficeAttachmentQueryVariables)({
        contentId: contentId,
        pageName: normalizedPageName,
        spaceKey: spaceKey,
        date: date
    });
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)((0, $brX63.default), {
        variables: variables,
        skip: skip,
        fetchPolicy: 'cache-first',
        __callerPackage__: "viewxls-macro"
    });
    if (skip) return {
        mediaFileId: null,
        collectionName: null,
        sourceContentId: null,
        isLoading: false,
        error: null
    };
    if (error) return {
        mediaFileId: null,
        collectionName: null,
        sourceContentId: null,
        isLoading: false,
        error: error
    };
    const contentNode = data?.content?.edges?.[0]?.node;
    const attachmentNodes = contentNode?.attachments?.nodes ?? [];
    const matchingAttachment = attachmentNodes.find((node)=>node?.title?.toLowerCase() === attachmentName?.toLowerCase());
    const mediaFileId = matchingAttachment?.extensions?.find((ext)=>ext?.key === 'fileId')?.value ?? null;
    const resolvedContentId = isCrossPage ? contentNode?.id ?? null : contentId;
    const collectionName = resolvedContentId ? `contentId-${resolvedContentId}` : null;
    return {
        mediaFileId: mediaFileId,
        collectionName: collectionName,
        sourceContentId: resolvedContentId,
        isLoading: loading && !data,
        error: null
    };
};










/**
 * Normalises an unknown thrown value to an Error instance.
 * Used by hooks that catch fetch or media errors.
 */ const $5e57852cb7cf13be$export$cc3b967c039ed3e7 = (err)=>{
    if (err instanceof Error) return err;
    return new Error(typeof err === 'string' ? err : 'Unknown error');
};


// The Atlassian Media Service generates a 'document.html' artifact when processing Excel
// files — an HTML rendering of the spreadsheet content.
const $125625f6f43b7a0f$var$DOCUMENT_HTML_ARTIFACT = 'document.html';
const $125625f6f43b7a0f$var$EMPTY_SHEET_NAMES = [];
const $125625f6f43b7a0f$var$createExcelMediaStatusError = (message)=>{
    const error = new Error(message);
    error.name = 'ExcelMediaStatusError';
    return error;
};
const $125625f6f43b7a0f$var$isExcelMediaStatusError = (error)=>error.name === 'ExcelMediaStatusError';
async function $125625f6f43b7a0f$var$fetchExcelHtmlArtifact(mediaStore, mediaFileId, collectionName, errorMessages) {
    const { data: mediaFile } = await mediaStore.getFile(mediaFileId, {
        collection: collectionName ?? undefined
    });
    const processingStatus = mediaFile.processingStatus;
    if (processingStatus === 'pending' || processingStatus === 'running') throw $125625f6f43b7a0f$var$createExcelMediaStatusError(errorMessages.pending);
    if (processingStatus === 'failed') throw $125625f6f43b7a0f$var$createExcelMediaStatusError(errorMessages.failed);
    const htmlArtifact = mediaFile.artifacts?.[$125625f6f43b7a0f$var$DOCUMENT_HTML_ARTIFACT];
    if (!htmlArtifact || htmlArtifact.processingStatus !== 'succeeded') return null;
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return mediaStore.getArtifactBinary(mediaFile.artifacts, $125625f6f43b7a0f$var$DOCUMENT_HTML_ARTIFACT, {
        collectionName: collectionName ?? undefined
    });
}
function $125625f6f43b7a0f$export$467725cecec65d4d({ isDisplayMode: isDisplayMode, isExcelAttachment: isExcelAttachment, mediaClient: mediaClient, mediaFileId: mediaFileId, collectionName: collectionName, attachmentName: attachmentName }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(!(!isDisplayMode || !isExcelAttachment || !mediaClient || !mediaFileId));
    const [htmlContent, setHtmlContent] = (0, $cozmU.useState)(null);
    const [sheetNames, setSheetNames] = (0, $cozmU.useState)([]);
    const [shouldShowNotice, setShouldShowNotice] = (0, $cozmU.useState)(false);
    const [error, setError] = (0, $cozmU.useState)(null);
    (0, $cozmU.useEffect)(()=>{
        let isCancelled = false;
        if (!isDisplayMode || !isExcelAttachment || !mediaClient || !mediaFileId) {
            setIsLoading(false);
            setShouldShowNotice(false);
            setHtmlContent(null);
            setSheetNames($125625f6f43b7a0f$var$EMPTY_SHEET_NAMES);
            setError(null);
            return;
        }
        const excelAttachmentName = attachmentName ?? '';
        setIsLoading(true);
        setShouldShowNotice(false);
        setHtmlContent(null);
        setSheetNames($125625f6f43b7a0f$var$EMPTY_SHEET_NAMES);
        setError(null);
        $125625f6f43b7a0f$var$fetchExcelHtmlArtifact(mediaClient.mediaStore, mediaFileId, collectionName, {
            pending: formatMessage((0, $289a2ded4c961958$export$a7357cdd1f0b0168).errorStillProcessing, {
                filename: excelAttachmentName
            }),
            failed: formatMessage((0, $289a2ded4c961958$export$a7357cdd1f0b0168).errorFailedToRetrieve, {
                filename: excelAttachmentName
            })
        }).then(async (htmlArtifactBlob)=>{
            if (!htmlArtifactBlob) {
                if (!isCancelled) {
                    setShouldShowNotice(true);
                    setHtmlContent(null);
                    setSheetNames($125625f6f43b7a0f$var$EMPTY_SHEET_NAMES);
                }
                return;
            }
            const content = await htmlArtifactBlob.text();
            const parsedSheetNames = (0, $a5b513a4466152da$export$5d1211828338680f)(content);
            if (isCancelled) return;
            if (content && parsedSheetNames.length > 0) {
                setHtmlContent(content);
                setSheetNames(parsedSheetNames);
                setShouldShowNotice(false);
            } else {
                setShouldShowNotice(true);
                setHtmlContent(null);
                setSheetNames($125625f6f43b7a0f$var$EMPTY_SHEET_NAMES);
            }
        }).catch((fetchError)=>{
            if (!isCancelled) {
                const normalizedError = (0, $5e57852cb7cf13be$export$cc3b967c039ed3e7)(fetchError);
                if ($125625f6f43b7a0f$var$isExcelMediaStatusError(normalizedError)) setError(normalizedError);
                else setShouldShowNotice(true);
                setHtmlContent(null);
                setSheetNames($125625f6f43b7a0f$var$EMPTY_SHEET_NAMES);
            }
        }).finally(()=>{
            if (!isCancelled) setIsLoading(false);
        });
        return ()=>{
            isCancelled = true;
        };
    }, [
        attachmentName,
        collectionName,
        formatMessage,
        isDisplayMode,
        isExcelAttachment,
        mediaClient,
        mediaFileId
    ]);
    return {
        isLoading: isLoading,
        htmlContent: htmlContent,
        sheetNames: sheetNames,
        shouldShowNotice: shouldShowNotice,
        error: error
    };
}






var $eMuR8 = parcelRequire("eMuR8");


function $22c3e72e9630f241$export$ff403a3b971ede6c({ mode: mode, mediaClient: mediaClient, mediaFileId: mediaFileId, collectionName: collectionName }) {
    const [isViewerLoading, setIsViewerLoading] = (0, $cozmU.useState)(true);
    const [viewerError, setViewerError] = (0, $cozmU.useState)(null);
    const [viewerSucceeded, setViewerSucceeded] = (0, $cozmU.useState)(false);
    const [thumbnailUrl, setThumbnailUrl] = (0, $cozmU.useState)(null);
    const blobUrlsRef = (0, $cozmU.useRef)(new Set());
    const hasTrackedSuccessRef = (0, $cozmU.useRef)(false);
    // Cleanup blob URLs on unmount to prevent memory leaks
    (0, $cozmU.useEffect)(()=>{
        const blobUrls = blobUrlsRef.current;
        return ()=>{
            blobUrls.forEach((url)=>URL.revokeObjectURL(url));
            blobUrls.clear();
        };
    }, []);
    // Fetch thumbnail URL only in editor mode — PDF/export always uses DocumentViewer directly.
    (0, $cozmU.useEffect)(()=>{
        let isCancelled = false;
        if (mode !== 'editor' || !mediaClient?.getImageUrl || !mediaFileId) {
            setThumbnailUrl(null);
            return;
        }
        Promise.resolve(mediaClient.getImageUrl(mediaFileId, {
            collection: collectionName ?? undefined
        })).then((nextThumbnailUrl)=>{
            if (!isCancelled) setThumbnailUrl(nextThumbnailUrl ?? null);
        }).catch(()=>{
            if (!isCancelled) setThumbnailUrl(null);
        });
        return ()=>{
            isCancelled = true;
        };
    }, [
        collectionName,
        mediaClient,
        mediaFileId,
        mode
    ]);
    const getContent = (0, $eMuR8.useStaticCallback)(async (pageStart, pageEnd)=>{
        if (!mediaClient || !mediaFileId) {
            const clientError = new Error('Media client or file ID not available');
            setViewerError(clientError);
            throw clientError;
        }
        try {
            return await mediaClient.mediaStore.getDocumentContent(mediaFileId, {
                pageStart: pageStart,
                pageEnd: pageEnd,
                collectionName: collectionName ?? undefined
            });
        } catch (fetchError) {
            const normalizedError = (0, $5e57852cb7cf13be$export$cc3b967c039ed3e7)(fetchError);
            setViewerError(normalizedError);
            throw normalizedError;
        }
    });
    const getPageImageUrl = (0, $eMuR8.useStaticCallback)(async (pageNumber, zoom)=>{
        if (!mediaClient || !mediaFileId) {
            const clientError = new Error('Media client or file ID not available');
            setViewerError(clientError);
            throw clientError;
        }
        try {
            const blob = await mediaClient.mediaStore.getDocumentPageImage(mediaFileId, {
                page: pageNumber,
                zoom: zoom,
                collectionName: collectionName ?? undefined
            });
            const newUrl = URL.createObjectURL(blob);
            blobUrlsRef.current.add(newUrl);
            return newUrl;
        } catch (fetchError) {
            const normalizedError = (0, $5e57852cb7cf13be$export$cc3b967c039ed3e7)(fetchError);
            setViewerError(normalizedError);
            throw normalizedError;
        }
    });
    const onSuccess = (0, $eMuR8.useStaticCallback)(()=>{
        if (!hasTrackedSuccessRef.current) {
            hasTrackedSuccessRef.current = true;
            setViewerSucceeded(true);
        }
        setIsViewerLoading(false);
    });
    return {
        isViewerLoading: isViewerLoading,
        viewerError: viewerError,
        viewerSucceeded: viewerSucceeded,
        hasTrackedSuccess: hasTrackedSuccessRef.current,
        thumbnailUrl: thumbnailUrl,
        getContent: getContent,
        getPageImageUrl: getPageImageUrl,
        onSuccess: onSuccess
    };
}


const $41e72e571cfafea7$var$styles = {
    documentScrollRoot: "_4bt5LAIZbP _2WAcuGIZbP _39xV02N91d _0jFU0VN91d _1mT5xdRAKS"
};
const $41e72e571cfafea7$var$ViewXlsMacroRendererComponent = ({ macroDefaultProps: macroDefaultProps, macroParams: macroParams })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { contentId: contentId, mode: mode, attributes: attributes, node: node } = macroDefaultProps;
    const extensionKey = macroDefaultProps.extensionKey ?? 'viewxls';
    const isDisplayMode = mode === 'renderer' || mode == null;
    const attributeMacroId = attributes?.macroId;
    const scrollRootId = attributeMacroId ? `${0, $glkQ6.DOCUMENT_SCROLL_ROOT_ID}-${attributeMacroId}` : (0, $glkQ6.DOCUMENT_SCROLL_ROOT_ID);
    const trackingAttributes = attributes ?? (0, $5kjCz.getMacroAttributesFromADFNode)(node);
    const experienceName = (0, $5kjCz.getExperienceName)(mode, node);
    const { attachmentName: attachmentName, pageName: pageName, spaceKey: spaceKey, date: date, mediaViewerWidth: mediaViewerWidth, mediaViewerHeight: mediaViewerHeight, htmlViewerWidth: htmlViewerWidth, htmlViewerHeight: htmlViewerHeight } = (0, $1HZKG.parseViewXlsMacroParams)(macroParams);
    const { mediaFileId: mediaFileId, collectionName: collectionName, sourceContentId: sourceContentId, isLoading: isLoading, error: error } = (0, $84092145cc3f41e1$export$d6d02870d99f0782)({
        contentId: contentId ?? null,
        attachmentName: attachmentName,
        pageName: pageName,
        spaceKey: spaceKey,
        date: date
    });
    const mediaClient = (0, $kCqKs.useMediaClient)({
        contentId: sourceContentId ?? contentId ?? undefined,
        readOnly: true
    });
    const isExcelAttachment = Boolean(attachmentName && (0, $1HZKG.isExcelFile)(attachmentName));
    const { isViewerLoading: isViewerLoading, viewerError: viewerError, viewerSucceeded: viewerSucceeded, hasTrackedSuccess: hasTrackedSuccess, thumbnailUrl: thumbnailUrl, getContent: getContent, getPageImageUrl: getPageImageUrl, onSuccess: onSuccess } = (0, $22c3e72e9630f241$export$ff403a3b971ede6c)({
        mode: mode,
        mediaClient: mediaClient,
        mediaFileId: mediaFileId,
        collectionName: collectionName
    });
    const { isLoading: isExcelHtmlLoading, htmlContent: excelHtmlContent, sheetNames: excelSheetNames, shouldShowNotice: shouldShowExcelNotice, error: excelError } = (0, $125625f6f43b7a0f$export$467725cecec65d4d)({
        isDisplayMode: isDisplayMode,
        isExcelAttachment: isExcelAttachment,
        mediaClient: mediaClient,
        mediaFileId: mediaFileId,
        collectionName: collectionName,
        attachmentName: attachmentName
    });
    // --- Error guards ---
    if (!attachmentName) {
        const missingNameError = new Error(formatMessage((0, $289a2ded4c961958$export$a7357cdd1f0b0168).errorNoFilename));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $JbVPK.MacroExperienceFailure), {
            name: experienceName,
            contentId: contentId ?? '',
            extensionKey: extensionKey,
            mode: mode,
            attributes: trackingAttributes,
            error: missingNameError
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: missingNameError
        }));
    }
    const displayError = error ?? excelError ?? viewerError;
    if (displayError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, !hasTrackedSuccess && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $JbVPK.MacroExperienceFailure), {
        name: experienceName,
        contentId: contentId ?? '',
        extensionKey: extensionKey,
        mode: mode,
        attributes: trackingAttributes,
        error: displayError
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: displayError
    }));
    if (isLoading || !mediaClient) return null;
    if (!mediaFileId) {
        const missingAttachmentError = new Error(formatMessage((0, $289a2ded4c961958$export$a7357cdd1f0b0168).errorAttachmentNotFound));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $JbVPK.MacroExperienceFailure), {
            name: experienceName,
            contentId: contentId ?? '',
            extensionKey: extensionKey,
            mode: mode,
            attributes: trackingAttributes,
            error: missingAttachmentError
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: missingAttachmentError
        }));
    } // Don't mount DocumentViewer while the Excel HTML artifact is loading — it will be
    // replaced by HtmlSheetViewer if the artifact succeeds, making the DocumentViewer mount wasted.
    if (isDisplayMode && isExcelAttachment && isExcelHtmlLoading) return null;
    if (isDisplayMode && isExcelAttachment) {
        if (excelHtmlContent && excelSheetNames.length > 0 && attachmentName) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a5b513a4466152da$export$e8078034ef788eda), {
            htmlContent: excelHtmlContent,
            sheetNames: excelSheetNames,
            width: htmlViewerWidth,
            height: htmlViewerHeight,
            attachmentName: attachmentName
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bX5uj.MacroExperienceSuccess), {
            name: experienceName,
            contentId: contentId ?? '',
            extensionKey: extensionKey,
            mode: mode,
            attributes: trackingAttributes
        }));
    } // In editor mode, show thumbnail if available, otherwise render nothing —
    // DocumentViewer is expensive and should not mount in editor mode.
    if (mode === 'editor') {
        if (thumbnailUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bX5uj.MacroExperienceSuccess), {
            name: experienceName,
            contentId: contentId ?? '',
            extensionKey: extensionKey,
            mode: mode,
            attributes: trackingAttributes
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
            src: thumbnailUrl,
            alt: formatMessage((0, $289a2ded4c961958$export$a7357cdd1f0b0168).thumbnailAlt, {
                filename: attachmentName
            }),
            "data-testid": "viewxls-macro-thumbnail"
        }));
        return null;
    }
    if (isDisplayMode && !attributeMacroId) return null;
     // Display mode: render DocumentViewer (PDF preview for all office file types)
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, isDisplayMode && shouldShowExcelNotice && attachmentName && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dac3ea759b53d371$export$81dbdf80cb4cbfe), {
        fileName: attachmentName,
        attachmentPageUrl: `/wiki/pages/viewpageattachments.action?pageId=${sourceContentId ?? contentId ?? ''}`,
        iconUrl: "/wiki/s/-/images/icons/excel.png"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Dynamic values from macro params cannot be expressed as static CSS
    , {
        style: {
            width: mediaViewerWidth,
            height: mediaViewerHeight,
            position: 'relative'
        },
        "data-testid": "viewxls-macro-viewer",
        "data-fabric-macro": attributes?.macroId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        id: scrollRootId,
        "data-testid": "viewxls-macro-scroll-root",
        style: {
            opacity: isViewerLoading ? 0 : 1
        },
        className: (0, $hekY6.default)([
            $41e72e571cfafea7$var$styles.documentScrollRoot
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a86m3.DocumentViewer), {
        getContent: getContent,
        getPageImageUrl: getPageImageUrl,
        zoom: 1,
        onSuccess: onSuccess
    })), viewerSucceeded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bX5uj.MacroExperienceSuccess), {
        name: experienceName,
        contentId: contentId ?? '',
        extensionKey: extensionKey,
        mode: mode,
        attributes: trackingAttributes
    })));
};
const $41e72e571cfafea7$export$768a6d3c79626c81 = (props)=>{
    const { macroDefaultProps: macroDefaultProps } = props;
    const { contentId: contentId, mode: mode, attributes: attributes, node: node } = macroDefaultProps;
    const extensionKey = macroDefaultProps.extensionKey ?? 'viewxls';
    const trackingAttributes = attributes ?? (0, $5kjCz.getMacroAttributesFromADFNode)(node);
    const experienceName = (0, $5kjCz.getExperienceName)(mode, node);
    const renderErrorFallback = ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $JbVPK.MacroExperienceFailure), {
            name: experienceName,
            contentId: contentId ?? '',
            extensionKey: extensionKey,
            mode: mode,
            attributes: trackingAttributes,
            error: error
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $289a2ded4c961958$export$a7357cdd1f0b0168).errorGeneric));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eCryJ.GenericErrorBoundary), {
        renderOnError: renderErrorFallback,
        attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($41e72e571cfafea7$var$ViewXlsMacroRendererComponent, props));
};
module.exports["ViewXlsMacroRenderer"] = $41e72e571cfafea7$export$768a6d3c79626c81;

});

parcelRegister("JbVPK", function(module, exports) {

var $2bAZx = parcelRequire("2bAZx");


var $5kjCz = parcelRequire("5kjCz");

function $98aa426b73cdcfeb$export$e394c7ce8301e00f({ attributes: attributes, children: children = null, contentId: contentId, extensionKey: extensionKey, error: error, mode: mode, name: name, source: source }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).fail({
            name: name,
            attributes: {
                ...attributes,
                source: source
            },
            error: error
        });
    }, [
        attributes,
        contentId,
        extensionKey,
        error,
        mode,
        name,
        source
    ]);
    return children;
}
module.exports["MacroExperienceFailure"] = $98aa426b73cdcfeb$export$e394c7ce8301e00f;

});

parcelRegister("kCqKs", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $204vt = parcelRequire("204vt");


var $3Yohw = parcelRequire("3Yohw");

const $ccf786f89fdd66e5$var$defaultMediaClientConfig = {
    useSha256ForUploads: true
};
const $ccf786f89fdd66e5$export$8b3e87ea56c3a345 = ({ contentId: contentId, onMediaSessionError: onMediaSessionError, config: config, readOnly: readOnly })=>{
    const authProvider = (0, $3Yohw.useAuthProvider)({
        contentId: contentId,
        onMediaSessionError: onMediaSessionError,
        readOnly: readOnly
    });
    return (0, $cozmU.useMemo)(()=>{
        if (!authProvider) return null;
        const mediaClientConfig = {
            authProvider: authProvider,
            ...$ccf786f89fdd66e5$var$defaultMediaClientConfig,
            ...config
        };
        return new (0, $204vt.MediaClient)(mediaClientConfig);
    }, [
        authProvider,
        config
    ]);
};
module.exports["useMediaClient"] = $ccf786f89fdd66e5$export$8b3e87ea56c3a345;

});

parcelRegister("3Yohw", function(module, exports) {

var $h5VWD = parcelRequire("h5VWD");


var $cozmU = parcelRequire("cozmU");


var $hP2NR = parcelRequire("hP2NR");

var $6Mfv2 = parcelRequire("6Mfv2");


var $dOBRD = parcelRequire("dOBRD");


var $fFmJj = parcelRequire("fFmJj");


var $c0rhi = parcelRequire("c0rhi");


var $kUcBh = parcelRequire("kUcBh");


var $aQVc0 = parcelRequire("aQVc0");

const $08cf8a02c21b4b5f$var$isMediaSessionQueryDataValid = (data)=>Boolean(data?.contentMediaSession);
const $08cf8a02c21b4b5f$var$isReadOnlyMediaSessionQueryDataValid = (data)=>Boolean(data?.contentMediaSession?.accessTokens?.readOnlyToken?.value && data?.contentMediaSession?.configuration && !!data.contentMediaSession.configuration.clientId && !!data.contentMediaSession.configuration.fileStoreUrl);
const $08cf8a02c21b4b5f$var$createMediaSessionConfig = (0, $dOBRD.default)((data)=>({
        clientId: data.contentMediaSession.configuration.clientId,
        baseUrl: data.contentMediaSession.configuration.fileStoreUrl,
        token: data.contentMediaSession.token.value
    }));
const $08cf8a02c21b4b5f$export$3c8c0548d7719730 = ({ contentId: contentId, onMediaSessionError: onMediaSessionError, readOnly: readOnly })=>{
    const readMediaSessionFragment = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $h5VWD.default),
        __callerPackage__: "media-client"
    });
    const getMediaSessionFromCache = (0, $cozmU.useCallback)(()=>{
        try {
            if (!contentId) throw new Error("[useAuthProvider] For 'ContentMediaSessionQuery' contentId is not provided.");
            let cachedData;
            cachedData = readMediaSessionFragment({
                id: `$ROOT_QUERY.contentMediaSession(${JSON.stringify({
                    contentId: contentId
                })})`
            });
            // wrapper to fit expectations around original query code data shape
            cachedData = {
                contentMediaSession: cachedData
            };
            if (!$08cf8a02c21b4b5f$var$isMediaSessionQueryDataValid(cachedData)) throw new Error("[useAuthProvider] For 'ContentMediaSessionQuery' invalid or missing data received from cache.");
            return cachedData;
        } catch  {
            // expected behavior
            // "readQuery" throws if there is no data in the store
            return;
        }
    }, [
        contentId,
        readMediaSessionFragment
    ]);
    const getMediaSessionFromServer = (0, $cozmU.useCallback)(async ()=>{
        try {
            if (!contentId) throw new Error("[useAuthProvider] For 'ContentMediaSessionQuery' contentId is not provided.");
            const response = await (0, $c0rhi.queryInterop)({
                query: (0, $kUcBh.ContentMediaSessionQuery),
                variables: {
                    contentId: contentId
                },
                fetchPolicy: 'network-only',
                __callerPackage__: "media-client"
            });
            if (!$08cf8a02c21b4b5f$var$isMediaSessionQueryDataValid(response.data)) throw new Error("[useAuthProvider] For 'ContentMediaSessionQuery' invalid or missing data received from server.");
            if (response?.error) throw response.error;
            return response.data;
        } catch (err) {
            if (onMediaSessionError) onMediaSessionError(err);
            throw err;
        }
    }, [
        contentId,
        onMediaSessionError
    ]);
    const getReadOnlyMediaSessionFromServer = (0, $cozmU.useCallback)(async ()=>{
        try {
            if (!contentId) throw new Error("[useAuthProvider] For 'ContentReadOnlyMediaSessionQuery' contentId is not provided.");
            const response = await (0, $c0rhi.queryInterop)({
                query: (0, $aQVc0.ContentReadOnlyMediaSessionQuery),
                variables: {
                    contentId: contentId
                },
                fetchPolicy: 'network-only',
                __callerPackage__: "media-client"
            });
            if (response?.error) throw response.error;
            if (!$08cf8a02c21b4b5f$var$isReadOnlyMediaSessionQueryDataValid(response.data)) throw new Error("[useAuthProvider] For 'ContentReadOnlyMediaSessionQuery' invalid or missing data received from server.");
            const session = response.data.contentMediaSession;
            return {
                clientId: session.configuration.clientId,
                baseUrl: session.configuration.fileStoreUrl,
                token: session.accessTokens.readOnlyToken.value
            };
        } catch (err) {
            if (onMediaSessionError) onMediaSessionError(err);
            throw err;
        }
    }, [
        contentId,
        onMediaSessionError
    ]);
    // Builds the media session config, including the token, from cache or server
    // It doesn't retry.
    const authProvider = (0, $cozmU.useCallback)(async ()=>{
        if (readOnly) return getReadOnlyMediaSessionFromServer();
        // countentId should be defined, otherwise this function shouldn't be called
        const cachedMediaSession = getMediaSessionFromCache();
        if (cachedMediaSession) {
            const expirationDateTime = new Date(cachedMediaSession.contentMediaSession.token.expiryDateTime);
            // It's expected to expire in 10mins. We'll renew it after 8mins.
            if (!(0, $6Mfv2.default)(new Date(), (0, $hP2NR.default)(expirationDateTime, -2))) return $08cf8a02c21b4b5f$var$createMediaSessionConfig(cachedMediaSession);
        }
        const freshMediaSession = await getMediaSessionFromServer();
        return $08cf8a02c21b4b5f$var$createMediaSessionConfig(freshMediaSession);
    }, [
        readOnly,
        getReadOnlyMediaSessionFromServer,
        getMediaSessionFromCache,
        getMediaSessionFromServer
    ]);
    if (!contentId) return null;
    return authProvider;
};
module.exports["useAuthProvider"] = $08cf8a02c21b4b5f$export$3c8c0548d7719730;

});

parcelRegister("h5VWD", function(module, exports) {
/**
 * @generated SignedSource<<136f6eb3c6ce4cf310c9c698de8d283b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3957ad7e9b1e26f3$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useAuthProvider_mediaSession",
    "selections": [
        {
            "concreteType": "MediaToken",
            "kind": "LinkedField",
            "name": "token",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "value"
                },
                {
                    "kind": "ScalarField",
                    "name": "duration"
                },
                {
                    "kind": "ScalarField",
                    "name": "expiryDateTime"
                }
            ]
        },
        {
            "concreteType": "MediaConfiguration",
            "kind": "LinkedField",
            "name": "configuration",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "clientId"
                },
                {
                    "kind": "ScalarField",
                    "name": "fileStoreUrl"
                }
            ]
        }
    ],
    "type": "ContentMediaSession"
};
$3957ad7e9b1e26f3$var$node.hash = "b6236d605ad5cddede0d44adc63193ec";
var $3957ad7e9b1e26f3$export$2e2bcd8739ae039 = $3957ad7e9b1e26f3$var$node;
module.exports["default"] = $3957ad7e9b1e26f3$export$2e2bcd8739ae039;

});

parcelRegister("hP2NR", function(module, exports) {
$parcel$export(module.exports, "default", () => $cf995fbf1bdbe48c$export$2e2bcd8739ae039);

var $kr6hK = parcelRequire("kr6hK");


var $bUJkW = parcelRequire("bUJkW");


var $3yGK6 = parcelRequire("3yGK6");

var $cf995fbf1bdbe48c$var$MILLISECONDS_IN_MINUTE = 60000;
function $cf995fbf1bdbe48c$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $3yGK6.default)(2, arguments);
    var amount = (0, $kr6hK.default)(dirtyAmount);
    return (0, $bUJkW.default)(dirtyDate, amount * $cf995fbf1bdbe48c$var$MILLISECONDS_IN_MINUTE);
}

});

parcelRegister("6Mfv2", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ef33fad4d0e8632$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $4ef33fad4d0e8632$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $3yGK6.default)(2, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var dateToCompare = (0, $dkBOe.default)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}

});

parcelRegister("kUcBh", function(module, exports) {

var $6ysok = parcelRequire("6ysok");

const $813a893306ac94c7$export$308add891a1b58f7 = (0, $6ysok.default);
module.exports["ContentMediaSessionQuery"] = $813a893306ac94c7$export$308add891a1b58f7;

});

parcelRegister("6ysok", function(module, exports) {
/**
 * @generated SignedSource<<08a4344353678a0bb207b26902cca8f0>>
 * @relayHash 82f12ac8b34ad91537ec9fdf459226f1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f65cd186bb1861751eac3934583c401749a09b36b0b45cf1430dc1816d509896
const $3ac88c8ffed86645$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ContentMediaSession",
            "kind": "LinkedField",
            "name": "contentMediaSession",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MediaToken",
                    "kind": "LinkedField",
                    "name": "token",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "duration"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "expiryDateTime"
                        }
                    ]
                },
                {
                    "concreteType": "MediaConfiguration",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "clientId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "fileStoreUrl"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentMediaSessionQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentMediaSessionQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "82f12ac8b34ad91537ec9fdf459226f1",
            "id": "f65cd186bb1861751eac3934583c401749a09b36b0b45cf1430dc1816d509896",
            "metadata": {},
            "name": "ContentMediaSessionQuery",
            "operationKind": "query",
            "text": "query ContentMediaSessionQuery($contentId:ID!){contentMediaSession(contentId:$contentId){token{value,duration,expiryDateTime},configuration{clientId,fileStoreUrl}}}"
        }
    };
}();
$3ac88c8ffed86645$var$node.hash = "f17b5112a287e607ae81ac1df8d1533e";
var $3ac88c8ffed86645$export$2e2bcd8739ae039 = $3ac88c8ffed86645$var$node;
module.exports["default"] = $3ac88c8ffed86645$export$2e2bcd8739ae039;

});

parcelRegister("aQVc0", function(module, exports) {

var $2fOul = parcelRequire("2fOul");

const $a5c308ec66cfd677$export$e4d69deb7dc731e2 = (0, $2fOul.default);
module.exports["ContentReadOnlyMediaSessionQuery"] = $a5c308ec66cfd677$export$e4d69deb7dc731e2;

});

parcelRegister("2fOul", function(module, exports) {
/**
 * @generated SignedSource<<b208ac6cd76cb0a2e5921252f1541930>>
 * @relayHash 1991400b2462d0b72d81f1298a73c504
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 44ec4e6ec111c9ff866a52aa9f2ebe84dc631f720e8ba2b72b24da9f321b53a5
const $a64aa8f901090a8a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ContentMediaSession",
            "kind": "LinkedField",
            "name": "contentMediaSession",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MediaAccessTokens",
                    "kind": "LinkedField",
                    "name": "accessTokens",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "MediaToken",
                            "kind": "LinkedField",
                            "name": "readOnlyToken",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "MediaConfiguration",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "clientId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "fileStoreUrl"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentReadOnlyMediaSessionQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentReadOnlyMediaSessionQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "1991400b2462d0b72d81f1298a73c504",
            "id": "44ec4e6ec111c9ff866a52aa9f2ebe84dc631f720e8ba2b72b24da9f321b53a5",
            "metadata": {},
            "name": "ContentReadOnlyMediaSessionQuery",
            "operationKind": "query",
            "text": "query ContentReadOnlyMediaSessionQuery($contentId:ID!){contentMediaSession(contentId:$contentId){accessTokens{readOnlyToken{value}},configuration{clientId,fileStoreUrl}}}"
        }
    };
}();
$a64aa8f901090a8a$var$node.hash = "a2478aa448d8ba882de605868f454f5f";
var $a64aa8f901090a8a$export$2e2bcd8739ae039 = $a64aa8f901090a8a$var$node;
module.exports["default"] = $a64aa8f901090a8a$export$2e2bcd8739ae039;

});

parcelRegister("1HZKG", function(module, exports) {

var $2zpUM = parcelRequire("2zpUM");

const $992f412cd97d28ae$var$DEFAULT_MEDIA_VIEWER_WIDTH = '95%';
const $992f412cd97d28ae$var$DEFAULT_MEDIA_VIEWER_HEIGHT = '650px';
const $992f412cd97d28ae$var$DEFAULT_HTML_VIEWER_WIDTH = '100%';
const $992f412cd97d28ae$var$DEFAULT_HTML_VIEWER_HEIGHT = '650px';
const $992f412cd97d28ae$export$eb48810096db92d8 = (macroParams)=>{
    const attachmentName = macroParams?.name?.value ?? macroParams?.['']?.value ?? macroParams?.defaultParameterValue?.value ?? null;
    const decodedPage = (0, $2zpUM.decodeLegacyMacroPageParam)(macroParams?.page?.value ?? null);
    const rawWidth = macroParams?.width?.value;
    const rawHeight = macroParams?.height?.value;
    return {
        attachmentName: attachmentName,
        pageName: decodedPage.pageName,
        spaceKey: macroParams?.space?.value ?? decodedPage.spaceKey,
        date: macroParams?.date?.value ?? decodedPage.date,
        mediaViewerWidth: rawWidth ? (0, $2zpUM.normalizeSizeParam)(rawWidth) : $992f412cd97d28ae$var$DEFAULT_MEDIA_VIEWER_WIDTH,
        mediaViewerHeight: rawHeight ? (0, $2zpUM.normalizeSizeParam)(rawHeight) : $992f412cd97d28ae$var$DEFAULT_MEDIA_VIEWER_HEIGHT,
        htmlViewerWidth: rawWidth ? (0, $2zpUM.normalizeSizeParam)(rawWidth) : $992f412cd97d28ae$var$DEFAULT_HTML_VIEWER_WIDTH,
        htmlViewerHeight: rawHeight ? (0, $2zpUM.normalizeSizeParam)(rawHeight) : $992f412cd97d28ae$var$DEFAULT_HTML_VIEWER_HEIGHT
    };
};
const $992f412cd97d28ae$export$e5fbc944c6f94589 = (filename)=>{
    const dotIdx = filename.lastIndexOf('.');
    if (dotIdx === -1) return false;
    return filename.substring(dotIdx + 1).toLowerCase().startsWith('xls');
};
const $992f412cd97d28ae$export$184444e10bf35293 = (filename)=>{
    if (filename.length > 35) return `${filename.substring(0, 10)}...${filename.substring(filename.length - 15)}`;
    return filename;
};
module.exports["parseViewXlsMacroParams"] = $992f412cd97d28ae$export$eb48810096db92d8;
module.exports["isExcelFile"] = $992f412cd97d28ae$export$e5fbc944c6f94589;
module.exports["truncateFileName"] = $992f412cd97d28ae$export$184444e10bf35293;

});

parcelRegister("2zpUM", function(module, exports) {
/**
 * Shared parameter parsing utilities for Office Connector macros
 * (viewxls, viewpdf, etc.).
 *
 * These utilities implement the same logic as the legacy ConverterMacro.java
 * backend and are shared across all office file macro packages.
 */ const $380d6d40e78d9881$export$80abf3a79956e7b0 = (size)=>{
    const numericSize = size.replace(/[^\d.]+/g, '');
    if (!numericSize) return size;
    if (size.endsWith('%')) return `${numericSize}%`;
    return `${numericSize}px`;
};
const $380d6d40e78d9881$export$3082a5716eb987e9 = (rawWidth, rawHeight, defaultWidth, defaultHeight)=>({
        width: rawWidth ? $380d6d40e78d9881$export$80abf3a79956e7b0(rawWidth) : defaultWidth,
        height: rawHeight ? $380d6d40e78d9881$export$80abf3a79956e7b0(rawHeight) : defaultHeight
    });
const $380d6d40e78d9881$export$c86b59de1acee041 = (rawPageParam)=>{
    if (!rawPageParam) return {
        pageName: null,
        spaceKey: null,
        date: null
    };
    const pageParam = rawPageParam.trim();
    if (!pageParam) return {
        pageName: null,
        spaceKey: null,
        date: null
    };
    const firstColon = pageParam.indexOf(':');
    const spacePart = firstColon !== -1 ? pageParam.slice(0, firstColon) || null : null;
    const titlePart = firstColon !== -1 ? pageParam.slice(firstColon + 1) : pageParam;
    let pageName = titlePart;
    let date = null;
    const datePathMatch = titlePart.match(/^\/(\d{4})\/(\d{2})\/(\d{2})\/(.+)$/);
    if (datePathMatch) {
        const [, year, month, day, title] = datePathMatch;
        date = `${month}/${day}/${year}`;
        pageName = title;
    }
    return {
        pageName: pageName || null,
        spaceKey: spacePart || null,
        date: date
    };
};
const $380d6d40e78d9881$export$a35ba7e9630557a6 = (date)=>{
    const parts = date.split('/');
    if (parts.length !== 3) return undefined;
    const [month, day, year] = parts;
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
};
const $380d6d40e78d9881$export$b7798d9ac552e5c0 = ({ contentId: contentId, pageName: pageName, spaceKey: spaceKey, date: date })=>{
    const normalizedPageName = pageName?.trim() || null;
    if (normalizedPageName) {
        const formattedDay = date ? $380d6d40e78d9881$export$a35ba7e9630557a6(date) : undefined;
        const variables = {
            contentStatus: [
                'current'
            ],
            title: normalizedPageName,
            type: formattedDay ? 'blogpost' : 'page'
        };
        if (spaceKey) variables.spaceKey = spaceKey;
        if (formattedDay) variables.postingDay = formattedDay;
        return variables;
    }
    return {
        contentId: contentId ?? undefined,
        contentStatus: [
            'current'
        ]
    };
};
module.exports["normalizeSizeParam"] = $380d6d40e78d9881$export$80abf3a79956e7b0;
module.exports["decodeLegacyMacroPageParam"] = $380d6d40e78d9881$export$c86b59de1acee041;
module.exports["buildOfficeAttachmentQueryVariables"] = $380d6d40e78d9881$export$b7798d9ac552e5c0;

});

parcelRegister("brX63", function(module, exports) {
/**
 * @generated SignedSource<<0c96f10d3264116bac575c1acf76ab2d>>
 * @relayHash 58b70ecccd9c88d5a0564eb4bb467f0c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f107b9eb0ae2e74b81fe44293a6d3feba92cdbd0e0f682d00960139c671adfdf
const $3792358011f8aa38$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "postingDay"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "title"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "type"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        },
        {
            "kind": "Variable",
            "name": "postingDay",
            "variableName": "postingDay"
        },
        {
            "kind": "Variable",
            "name": "spaceKey",
            "variableName": "spaceKey"
        },
        {
            "kind": "Variable",
            "name": "status",
            "variableName": "contentStatus"
        },
        {
            "kind": "Variable",
            "name": "title",
            "variableName": "title"
        },
        {
            "kind": "Variable",
            "name": "type",
            "variableName": "type"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 250
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "title"
    }, v10 = {
        "concreteType": "KeyValueHierarchyMap",
        "kind": "LinkedField",
        "name": "extensions",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "key"
            },
            {
                "kind": "ScalarField",
                "name": "value"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useViewXlsDataQuery",
            "selections": [
                {
                    "args": v6 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "args": v8 /*: any*/ ,
                                            "concreteType": "PaginatedContentList",
                                            "kind": "LinkedField",
                                            "name": "attachments",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "Content",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "storageKey": "attachments(first:250)"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useViewXlsDataQuery",
            "selections": [
                {
                    "args": v6 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "args": v8 /*: any*/ ,
                                            "concreteType": "PaginatedContentList",
                                            "kind": "LinkedField",
                                            "name": "attachments",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "Content",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        v7 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "storageKey": "attachments(first:250)"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "58b70ecccd9c88d5a0564eb4bb467f0c",
            "id": "f107b9eb0ae2e74b81fe44293a6d3feba92cdbd0e0f682d00960139c671adfdf",
            "metadata": {},
            "name": "useViewXlsDataQuery",
            "operationKind": "query",
            "text": "query useViewXlsDataQuery($contentId:ID,$contentStatus:[String],$spaceKey:String,$title:String,$type:String,$postingDay:String){content(id:$contentId,status:$contentStatus,spaceKey:$spaceKey,title:$title,type:$type,postingDay:$postingDay){edges{node{id,attachments(first:250){nodes{title,extensions{key,value},id}}}}}}"
        }
    };
}();
$3792358011f8aa38$var$node.hash = "af1ae137898ad1c9b71f1f894c3f69de";
var $3792358011f8aa38$export$2e2bcd8739ae039 = $3792358011f8aa38$var$node;
module.exports["default"] = $3792358011f8aa38$export$2e2bcd8739ae039;

});


//# sourceMappingURL=ViewXlsMacroRenderer.8dd0d318.js.map
